import { Routes } from '@angular/router';
import { roleGuard } from '../../core/guards/role.guard';
import { ShellComponent } from './layout/shell.component';
import { AuditComponent } from './audit/audit.component';
import { ByeLawsComponent } from './bye-laws/bye-laws.component';
import { AdministrationComponent } from './administration/administration.component';
import { AreasComponent } from './areas/areas.component';
import { LidarSurveyComponent } from './lidar-survey/lidar-survey.component';
import { LocationTypesComponent } from './location-types/location-types.component';
import { ComplianceRunsComponent } from './compliance-runs/compliance-runs.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MeasurementsComponent } from './measurements/measurements.component';
import { OfficerDashboardComponent } from './flags/officer-dashboard.component';
import { PlotBoundariesComponent } from './plot-boundaries/plot-boundaries.component';
import { PilotsComponent } from './pilots/pilots.component';
import { PlansComponent } from './plans/plans.component';

export const enforcementRoutes: Routes = [
  {
    path: '',
    component: ShellComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', component: DashboardComponent },
      {
        path: 'flags',
        canActivate: [roleGuard('officer', 'config_admin')],
        component: OfficerDashboardComponent,
        data: { mobileBack: '/enforcement/dashboard' },
      },
      {
        path: 'bye-laws',
        canActivate: [roleGuard('officer', 'config_admin')],
        component: ByeLawsComponent,
        data: { mobileBack: '/enforcement/dashboard' },
      },
      {
        path: 'administration',
        canActivate: [roleGuard('config_admin')],
        component: AdministrationComponent,
        data: { mobileBack: '/enforcement/dashboard' },
      },
      {
        path: 'pilots',
        canActivate: [roleGuard('config_admin')],
        component: PilotsComponent,
        data: { mobileBack: '/enforcement/dashboard' },
      },
      {
        path: 'plans',
        canActivate: [roleGuard('verifier', 'config_admin')],
        component: PlansComponent,
        data: { mobileBack: '/enforcement/dashboard' },
      },
      {
        path: 'areas',
        canActivate: [roleGuard('officer', 'config_admin')],
        component: AreasComponent,
        data: { mobileBack: '/enforcement/dashboard' },
      },
      {
        path: 'lidar-survey',
        canActivate: [roleGuard('officer', 'config_admin')],
        component: LidarSurveyComponent,
        data: { mobileBack: '/enforcement/dashboard' },
      },
      {
        path: 'plot-boundaries',
        canActivate: [roleGuard('config_admin')],
        component: PlotBoundariesComponent,
        data: { mobileBack: '/enforcement/dashboard' },
      },
      {
        path: 'location-types',
        canActivate: [roleGuard('config_admin')],
        component: LocationTypesComponent,
        data: { mobileBack: '/enforcement/dashboard' },
      },
      { path: 'scan-area', redirectTo: 'lidar-survey', pathMatch: 'full' },
      { path: 'batch-scan', redirectTo: 'lidar-survey', pathMatch: 'full' },
      {
        path: 'scans',
        redirectTo: 'lidar-survey',
        pathMatch: 'full',
      },
      {
        path: 'measurements',
        canActivate: [roleGuard('officer', 'config_admin')],
        component: MeasurementsComponent,
        data: { mobileBack: '/enforcement/dashboard' },
      },
      {
        path: 'compliance-runs',
        canActivate: [roleGuard('officer', 'config_admin')],
        component: ComplianceRunsComponent,
        data: { mobileBack: '/enforcement/dashboard' },
      },
      {
        path: 'audit',
        canActivate: [roleGuard('config_admin', 'officer')],
        component: AuditComponent,
        data: { mobileBack: '/enforcement/dashboard' },
      },
    ],
  },
];
